import { projectStatus } from "@planzone/dto";
import { Boundaries } from "@planzone/core";
import { State } from "./types";

function handleRetrieveProjectGantt(
  state: State,
  { gantt }: Boundaries["retrieveProjectGantt"]["success"],
): State {
  // const indexes = gantt.projects.map((project) => ({
  //   project,
  //   index: state.gantt.projects.findIndex(({ uuid }) => uuid === project.uuid),
  // }));

  return state;

  // return {
  //   ...state,
  //   gantt: {
  //     projects: indexes.reduce(
  //       (projects, { project, index }) =>
  //         index !== -1
  //           ? [
  //               ...projects.slice(0, index),
  //               { ...projects[index], ...project, shallow: false },
  //               ...projects.slice(index + 1),
  //             ]
  //           : [...projects, { ...project, shallow: false }],
  //       state.gantt.projects.map((p) => ({
  //         ...p,
  //         status: p.status ? p.status : { ...projectStatus, uuid: "" },
  //       })),
  //     ),
  //     constraints: [...state.gantt.constraints, ...gantt.constraints],
  //   },
  // };
}

export { handleRetrieveProjectGantt };
